import { useDebounceCallback } from '@react-hook/debounce';
import { useEffect, useState } from 'react';

const useRegexOptionsCounter = ({ value, options }) => {
  const [regexCounter, setRegexCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const calculateRegexOptionsCounter = useDebounceCallback(() => {
    try {
      if (value?.length === 0) throw new Error();

      const regex = new RegExp(value);
      const counter = (options || []).filter(option =>
        regex.test(option.value)
      ).length;
      setRegexCounter(counter);
    } catch (e) {
      setRegexCounter(0);
    } finally {
      setIsLoading(false);
    }
  }, 500);

  useEffect(() => {
    setIsLoading(true);
    calculateRegexOptionsCounter();
  }, [value, options]);

  return [regexCounter, isLoading];
};

export default useRegexOptionsCounter;
